import { Link } from "react-router-dom";
import HeroMark from "@/components/HeroMark";
import Logo from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen grid-cols-1 bg-arjuna-ink lg:grid-cols-2" data-testid="auth-shell">
      {/* Brand panel */}
      <div className="relative hidden overflow-hidden lg:block">
        <img
          src="https://images.pexels.com/photos/30596239/pexels-photo-30596239.jpeg"
          alt="Earth"
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-arjuna-ink via-arjuna-ink/70 to-arjuna-blue/20" />
        <div className="absolute inset-0 grid-lines opacity-30" />
        <div className="relative flex h-full flex-col justify-between p-12">
          <Link to="/">
            <Logo className="h-8 w-8" withWordmark />
          </Link>
          <div className="flex justify-center">
            <HeroMark className="h-56 w-56" />
          </div>
          <div>
            <p className="overline mb-3">Geospatial Intelligence</p>
            <p className="max-w-sm font-heading text-2xl leading-tight text-white">
              From orbit to shoreline to soil. one lens over India.
            </p>
          </div>
        </div>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center px-6 py-16 sm:px-12">
        <div className="w-full max-w-md">
          <div className="mb-10 lg:hidden">
            <Link to="/">
              <Logo className="h-8 w-8" withWordmark />
            </Link>
          </div>
          <h1 className="font-heading text-3xl font-medium tracking-tight text-white sm:text-4xl">{title}</h1>
          {subtitle && <p className="mt-3 text-slate-400">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-sm text-slate-400">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
